<template>
  <div class="mx-[12px]">
    <Border v-if="bannerData && bannerData.picture" radius="10px" borderWidth="2px">
      <div class="w-full h-[108px] header-banner box-border ">
        <div class="w-full h-full  rounded-[7.5px] overflow-hidden ">
          <img @click="handleBannerClick" v-if="bannerData && bannerData.picture"
            :src="VITE_IMG_URL + bannerData.picture" :alt="bannerData.title || 'Banner'"
            class="w-full h-full object-cover">
        </div>
      </div>
    </Border>


    <div class="color-[#FFFFFF] text-[14px] font-bold mt-[32px]">
      <!-- Por favor, insira o codigo de resgate -->
      {{ t('codes.title') }}
    </div>
    <div class="moneyseary py-[4px] px-[10px] overflow-hidden">
      <input v-model="parmes.code" class="search-input auth-input" :placeholder="t('codes.placeholder')">
      <img :src="getAssetsFile('home/zu15.png')" alt="" class="money-icon" v-if="parmes.code != ''"
        @click="parmes.code = ''">
    </div>
    <div class="flex items-center justify-center mt-[22px]">
      <Button type="medium" class="mt-[28px] Recharge" :class="{ animated: rechargeBtnAnimated }"
        @click="handleRechargeClick">
        {{ t('codes.redeemButton') }}
      </Button>
    </div>
    <div class="rules-container mt-[22px] color-[#60B289] lh-[34px] text-[10px] p-11px rounded-[8px]">
      <div class="lh-[17px] flex items-start">
        <div class="mr-[5.5px]">
          <img :src="getAssetsFile('activity/codesRulesItemIcon.png')" alt=""
            class="w-[12px] h-[14px] object-cover align-middle">
        </div>
        <div>
          {{ t('codes.rule1') }}
        </div>
      </div>
      <div class="lh-[17px] flex items-start">
        <div class="mr-[5.5px]">
          <img :src="getAssetsFile('activity/codesRulesItemIcon.png')" alt=""
            class="w-[12px] h-[14px] object-cover align-middle">
        </div>
        <div>
          {{ t('codes.rule2') }}
        </div>
      </div>
      <div class="lh-[17px] flex items-start">
        <div class="mr-[5.5px]">
          <img :src="getAssetsFile('activity/codesRulesItemIcon.png')" alt=""
            class="w-[12px] h-[14px] object-cover align-middle">
        </div>
        <div>
          {{ t('codes.rule3') }}
        </div>

      </div>
      <div class="lh-[17px] flex items-start">
        <div class="mr-[5.5px]">
          <img :src="getAssetsFile('activity/codesRulesItemIcon.png')" alt=""
            class="w-[12px] h-[14px] object-cover align-middle">
        </div>
        <div>
          {{ t('codes.rule4') }}
        </div>

      </div>
    </div>

    <!-- 添加 RewardDialog 组件 -->
    <RewardDialog v-model:show="showRewardDialog" :amount="rewardAmount" @confirm="handleRewardConfirm" />
  </div>
</template>

<script setup lang="ts">
import { Border } from "@/components/Border"
import { Button } from '@/components/Button'
import { ref, onMounted } from 'vue'
import * as GameApi from '@/api/game'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'
import RewardDialog from '@/components/RewardDialog.vue'
import { numberFormat } from '@/utils/formatter'
import { getAssetsFile } from '@/utils/pub-use'
const VITE_IMG_URL = import.meta.env.VITE_IMG_URL
const { t } = useI18n()
const router = useRouter()

const parmes = ref({
  code: ''
})

const rechargeBtnAnimated = ref(false)
// 添加弹窗相关的响应式变量
const showRewardDialog = ref(false)
const rewardAmount = ref<any>({})

// Banner 相关数据
const bannerData = ref(null)

// 添加格式化函数
const formatAmount = (val: number) => {
  if (val == null) return '0,00';
  return numberFormat(val, { minDecimals: 2 });
};

function handleRechargeClick() {
  // 检查是否输入了兑换码
  if (!parmes.value.code || parmes.value.code.trim() === '') {
    window.$toast(t('codes.pleaseEnterCode'))
    return
  }

  rechargeBtnAnimated.value = false
  void rechargeBtnAnimated.value // 强制刷新
  setTimeout(() => { rechargeBtnAnimated.value = true }, 10)
  setTimeout(() => { rechargeBtnAnimated.value = false }, 400)

  GameApi.code(parmes.value).then((res) => {
    // 格式化金额并显示弹窗
    rewardAmount.value = res.data
    showRewardDialog.value = true
  })
}

// 处理奖励弹窗确认事件
function handleRewardConfirm() {
  // 关闭弹窗
  showRewardDialog.value = false
}

// 获取Banner数据
const fetchBannerData = async () => {
  try {
    const res = await GameApi.getAllBanners()
    if (res && res.data && Array.isArray(res.data)) {
      // 查找position为10的banner
      const targetBanner = res.data.find(item => item.position === 10)
      if (targetBanner) {
        bannerData.value = targetBanner
      }
    }
  } catch (error) {
    console.error('获取Banner数据失败:', error)
  }
}

// 处理Banner点击事件
const handleBannerClick = () => {
  if (!bannerData.value || !bannerData.value.url) return

  const url = bannerData.value.url

  // 判断是否为外部链接
  if (url.startsWith('http://') || url.startsWith('https://')) {
    // 外部链接，在新窗口打开
    window.open(url, '_blank')
  } else if (url.includes('www.')) {
    // 包含www但没有协议，添加https://
    window.open('https://' + url, '_blank')
  } else {
    // 内部路由，使用router跳转
    try {
      router.push(url)
    } catch (error) {
      // 如果路由跳转失败，尝试使用window.location
      window.location.href = url
    }
  }
}

// 组件挂载时获取Banner数据
onMounted(() => {
  fetchBannerData()
})
</script>

<style lang="scss" scoped>
.rules-container {
  background: rgba(0, 60, 49, 0.9);
}

.header-banner {
  // background: getPath('activity/codeHeadBorderBg.png') no-repeat center center;
  background-size: 100% 100%;
}

.moneyseary {
  height: 32px;
  background: getPath('activity/codeInputBorderBg.png') no-repeat center center;
  background-size: 100% 100%;
  // border-radius: 50px;
  display: flex;
  align-items: center;
  // padding: 0 20px;
  margin-top: 17px;
}

.money-prefix {
  color: #fff;
  font-size: 12px;
  flex-shrink: 0;
  font-weight: bold;
}

.search-input {
  flex: 1;
  border-radius: 50px;
  border: none;
  outline: none;
  background: transparent !important;
  color: #fff;
  font-size: 12px;
  height: 100%;
  margin-left: 5px;
  margin-right: 5px;
}

.money-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

input::placeholder {
  color:#ADB1B0;
  font-size: 11px;
}

.auth-input {
  caret-color: #ADB1B0;
}

.Recharge {}

.Recharge::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #fff 0%, #43C36B 50%, #fff 100%);
  opacity: 0.25;
  border-radius: 6px;
  transform: translateX(-50%) scaleX(0);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  pointer-events: none;
}

.Recharge.animated::before {
  transform: translateX(-50%) scaleX(1);
}

.Recharge,
.Recharge>* {
  position: relative;
  z-index: 2;
}
</style>
